import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DipartimentiTableRow from './DipartimentiTableRow'
import TablePager from '../TablePager'
import PrintButton from '../PrintButton'
import TableColumnOrdered from '../TableColumnOrdered'
import PdfButton from '../PdfButton'

class DipartimentiTable extends Component {
    constructor(props) {
        super(props);
        let rv = this.updateData(props.count, props.rowperpage);
        this.state = {
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };

        this.onChangePage = this.onChangePage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let rv = this.updateData(nextProps.count, nextProps.rowperpage);
        this.setState(rv);
    }

    updateData(count, rowperpage){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        return {pages, lastPage}
    }

    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }

    onPdfExportClick(tipo){
        if (this.props.onExportPdf !== undefined){
            this.props.onExportPdf(tipo)
        }
    }

    render() {
        return (
            <div className="ep-outer-table">
                <div className="ep-inner-scrollable-table">
        <table id="printme" className="ui striped sortable compact celled table">
            <thead>
            <tr><th colSpan="4">
                {/*<a className="pointer" onClick={this.props.onNuovoItem}>*/}
                    {/*<div className="ui left floated small primary labeled icon button">*/}
                        {/*<i className="plus icon"></i> Nuovo Dipartimento*/}
                    {/*</div>*/}
                {/*</a>*/}
                <PrintButton title={"Stampa dati visualizzati"}/>
                <PdfButton title="PDF elenco completo" onClick={(ev) => (this.onPdfExportClick())} />
                <TablePager
                    pages={this.state.pages} page={this.props.page}
                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr>
            <tr>
                <TableColumnOrdered
                    className="eight wide"
                    name="dipartimento"
                    orderActive={this.props.tableOrderingField === "dipartimento"}
                    orderFields="d.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Dipartimento</TableColumnOrdered>
                <TableColumnOrdered
                    className="seven wide"
                    name="organizzazione"
                    orderActive={this.props.tableOrderingField === "organizzazione"}
                    orderFields="o.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Organizzazione</TableColumnOrdered>

                <th className="one wide no-print"></th>
            </tr>
            </thead>
            <tbody>
            {this.props.items.map((item) => (
                <DipartimentiTableRow item={item} key={item.idDipartimento} onDeleteDipartimento={this.props.onDeleteItem} onModificaDipartimento={this.props.onModificaItem} readOnly={this.props.readOnly}/>
            ))}
            </tbody>
            <tfoot>
            </tfoot>
        </table></div></div>)
    }

}

DipartimentiTable.PropTypes = {
    items: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onDeleteItem: PropTypes.func,
    onNuovoItem: PropTypes.func,
    onModificaItem: PropTypes.func,
    readOnly: PropTypes.bool
}
export default DipartimentiTable;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/DipartimentiTable.js
 **/